import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { getAxiosResponse, handleError } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import { getLoggedInUserRole } from "../../services/Util";
import { dateConvertToTimeStamp, dateFormat, dateDifference } from "../../services/Util";
import { useSelector, useDispatch } from "react-redux";
import DateRangeSelector from "../../components/dashboard/calendars/DateRangeSelector";
import ProjectDashboardReports from "./ProjectDashboardReports";
import OperationalCostReports from "./OperationalCostReports";
import TMDashboardReports from "./TMDashboardReports";
import {rangeSelected, departmentSelected, reset} from "../../redux/reducers/ReportsSlice";
import { ConditionalBlock } from "../../ConditionalBlock";
import DateFormat from "../DateFormat";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";
import moment from "moment-timezone";

export default function Reports() {
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const roleArray = getLoggedInUserRole();
  const refCalendar = useRef(null);
  const refToggle = useRef(null);

  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [selectedDateRangeOriginalFormat, setSelectedDateRangeOriginalFormat] = useState([]);
  const selectedDepartment = useSelector((ReportsSlice) => ReportsSlice.reports).department;

  const [activeTab, setActiveTab] = useState(Constants.PROJECT_DASHBOARD);
  const [departments, setDepartments] = useState([]);
  const [contentTypes, setContentTypes] = useState([]);

  const [toggle, toggleCal] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [displayMonthValue, setMonthValue] = useState(1);

  const [reloadPage, setReloadPage] = useState(true);
  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState({value:'USD',symbol:'$'});

  const bootstrapData = useSelector(
    (reduxStore) => reduxStore.customer_bootstrap_data
  ).value;

  const setDepartment = (event) => {
    dispatch(departmentSelected(event))
  }

  const showRangeCalendar = (e) => {    
    toggle ? toggleCal(false) : toggleCal(true);
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      requiredElement.focus();
    }
  };

  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleCal(false);
    }
  };

  const getMonthValue = () => {
    months.filter((option) => {
      var monthsDiff = dateDifference(selectedDateRange[1], selectedDateRange[0], "months");
      if (option.value === Math.floor(monthsDiff)) {
        setMonthValue(option.value);
      }
    });
  };

  const months = [
    { label: "Last 1 month", value: 1 },
    { label: "Last 3 months", value: 3 },
    { label: "Last 6 months", value: 6 },
    { label: "Last 12 months", value: 12 },
  ];

  useEffect(() => {
    getMonthValue();
    setSelectedDateRange(getDefaultDateRange());
    setDateRange(getDefaultDateRange());
    setSelectedDateRangeOriginalFormat(getDefaultDateRangeWithOriginalFormat())
    fetchDepartments();
    getProjectContentTypes();
  }, []);

  useEffect(() => {
    if(bootstrapData?.features?.INTERNATIONAL_CURRENCY && (activeTab === Constants.OPERATIONAL_COST)){
        fetchAllAvailableCurrencies();
    }
  }, [activeTab]);

  useEffect(() => {
    setDateRange(selectedDateRange);
    setTimeout(function () {
      toggleCal(false);
    }, 2000);
  }, [selectedDateRange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const icon = event.target?.classList?.contains("calender-icon");
      if (!refCalendar.current?.contains(event.target) && !refToggle.current?.contains(event.target) && !icon) {
        toggleCal(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("focus", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("focus", handleClickOutside, true);
    };
  }, [refCalendar]);

  const params = (includeCurrency) => {
    let queryParam = Constants.BLANK;
    if (selectedDepartment?.value) {
      queryParam += queryParam === Constants.BLANK ? `?` : `&`;
      queryParam += `userGroupIds=${selectedDepartment.value}`;
    }
    const dateTimestamp = dateConvertToTimeStamp();
    queryParam += queryParam === Constants.BLANK ? `?` : `&`;
    if(includeCurrency) {
      queryParam += `currency=${currency?.value}&`;
    }
    queryParam += `_=${dateTimestamp}`;
    return queryParam;
  };

  const getDefaultDateRange = () => {
    let startDate = moment().subtract(1, "months").startOf("day")
    let endDate = moment().endOf("day")
    return [
      dateUtil.format(startDate, Constants.DATE_FORMAT_MM_DD_YY, null),
      dateUtil.format(endDate, Constants.DATE_FORMAT_MM_DD_YY, null)
    ]
  }

  const getDefaultDateRangeWithOriginalFormat = () => {
    let startDate = moment().subtract(1, "months").startOf("day")
    let endDate = moment().endOf("day")
    return [
      dateUtil.formatWithoutConversion(startDate),
      dateUtil.formatWithoutConversion(endDate)
    ]
  }

  const getProjectContentTypes = () => {
    getAxiosResponse(APIUrls.PROJECT_TYPE)
      .then((res) => {
        if (res.data.code === 200) {
          let options = res.data.data.map((contentType) => ({
            label: translate("report.content_type." + contentType),
            value: contentType,
          }));
          options.unshift({ value: "", label: translate("report.project_dashboard.assets_by_languages.content_type-all") });
          setContentTypes(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const fetchDepartments = () => {
    if (!roleArray.includes("ROLE_VENDOR")) {
      getAxiosResponse(APIUrls.DEPARTMENT_URL)
        .then((res) => {
          if (res.data.code === 200) {
            var departs = res.data.data;
            departs.unshift({ id: "", name: translate("project_request.all_departments") });
            const options = res.data.data.map(({ id, name }) => ({
              label: name,
              value: id,
            }));
            setDepartments(options);
          }
        })
        .catch((err) => {
          handleError(err);
        });
    }
  };

  const fetchAllAvailableCurrencies = () => {
    getAxiosResponse(APIUrls.ALL_AVAILABLE_CURRENCIES)
    .then((result) => {
        let options = result?.data?.data?.map((currency) => ({
          label : currency.label,
          value : currency.code,
          symbol: currency.symbol,
          defaultValue : currency.defaultValue
        }))
        setCurrencies(options);
        let defaultCurrencies = options.filter(currency => currency.defaultValue);
        if(defaultCurrencies?.length > 0){
            setCurrency(defaultCurrencies[0]);
        }
    })
    .catch((err) => {
        handleError(err);
    });
  }


  const onDateChange = (returnValue) => {
    let range = [
        dateUtil.format(returnValue[0], Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS, null),
        dateUtil.format(returnValue[1], Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS, null)
    ]        
    setSelectedDateRangeOriginalFormat([dateUtil.formatWithoutConversion(returnValue[0]),dateUtil.formatWithoutConversion(returnValue[1])])    
    setSelectedDateRange(range);
  }

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="white-bg mh-550 mar-bot50">
              <div className="vender-edit-page report-page">
                <div className="vender-heading">
                  <h4>Reports</h4>
                </div>
                <div className="listing-tab-block flex">
                  <ul className="listing-tab-link flex">
                    <li>
                      <button className={activeTab === Constants.PROJECT_DASHBOARD ? "active" : ""} onClick={() => setActiveTab(Constants.PROJECT_DASHBOARD)}>
                        Projects Dashboard
                      </button>
                    </li>
                    <li>
                      <button className={activeTab === Constants.OPERATIONAL_COST ? "active" : ""} onClick={() => setActiveTab(Constants.OPERATIONAL_COST)}>
                        Operational Costs
                      </button>
                    </li>
                    <li>
                      <button className={activeTab === Constants.TM_DASHBOARD ? "active" : ""} onClick={() => setActiveTab(Constants.TM_DASHBOARD)}>
                        TM Dashboard
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="report-content">
                  <div className="flex gap20 mar-bot25 flex-align-center justify-end">

                    <ConditionalBlock condition={bootstrapData?.features?.INTERNATIONAL_CURRENCY && (activeTab === Constants.OPERATIONAL_COST)}>
                    <div className="global-dropdown-block m-0">
                      <Select
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix="cw"
                        options={currencies}
                        value={currency}
                        onChange={(event) => setCurrency(event)}
                      />
                    </div>
                    </ConditionalBlock>

                    <div className="global-dropdown-block m-0">
                      <Select
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix="cw"
                        options={departments}
                        value={selectedDepartment === "" ? departments[0] : selectedDepartment}
                        onChange={(event) => setDepartment(event)}
                      />
                    </div>
                    
                    <div id="filterBtn" className="filter-content">
                      <div className="filter-inline-list m-0">
                        <div className="filter-date flex-center">
                          <button
                            className="calenderIcon"
                            onClick={(e) => showRangeCalendar(e)}
                            onKeyDown={(e) => closeCalendar(e)}
                            ref={refToggle}
                            tabIndex={0}
                            aria-label={"Start date " + dateUtil.format(dateRange[0]) + " End Date " + dateUtil.format(dateRange[1])}
                            aria-expanded={toggle}>
                            <svg className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
                              <path
                                d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                                fill="#3564EB"
                              />
                            </svg>
                          </button>

                          {toggle ? (
                            <div ref={refCalendar} onKeyDown={(e) => closeCalendar(e)}>
                              <DateRangeSelector
                                calendarType="US"
                                locale="en"
                                selectRange={true}
                                className={"dashCalendar"}
                                onDateChange = {onDateChange}
                                value = {[new Date(selectedDateRange[0]), new Date(selectedDateRange[1])]}
                                showDoubleView={true}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="flex-center white-space">
                            <span onClick={(e) => showRangeCalendar(e)} ref={refToggle}>
                              <DateFormat date={dateRange[0]} timezone={null}/>
                            </span>
                            <svg className="interchange-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path
                                d="M2.53787 6.22222L9.29787 6.22222V5.33333L2.53787 5.33333L4.18675 3.67555C4.2279 3.63411 4.26048 3.58498 4.28264 3.53094C4.3048 3.47691 4.3161 3.41905 4.31589 3.36065C4.31568 3.30225 4.30398 3.24447 4.28144 3.19059C4.2589 3.13672 4.22597 3.08781 4.18453 3.04666C4.14309 3.00552 4.09396 2.97293 4.03992 2.95078C3.98589 2.92862 3.92803 2.91732 3.86963 2.91753C3.81123 2.91774 3.75344 2.92944 3.69957 2.95198C3.6457 2.97452 3.59679 3.00745 3.55564 3.04889L0.840088 5.77778L3.55564 8.50666C3.59516 8.55345 3.64393 8.59156 3.69887 8.61861C3.75382 8.64566 3.81376 8.66106 3.87494 8.66385C3.93611 8.66664 3.99721 8.65675 4.05439 8.63481C4.11156 8.61287 4.16359 8.57935 4.2072 8.53635C4.25081 8.49336 4.28506 8.44181 4.30781 8.38495C4.33056 8.32809 4.34131 8.26714 4.33939 8.20593C4.33747 8.14472 4.32292 8.08457 4.29666 8.02924C4.27039 7.97392 4.23297 7.92462 4.18675 7.88444L2.53787 6.22222Z"
                                fill="#6D7080"
                              />
                              <path d="M10.2222 5.33334H11.5555V6.22222H10.2222V5.33334Z" fill="#6D7080" />
                              <path d="M12.4443 5.33334H13.3332V6.22222H12.4443V5.33334Z" fill="#6D7080" />
                              <path
                                d="M12.409 7.93778C12.3678 7.89634 12.3189 7.86341 12.265 7.84087C12.2112 7.81834 12.1534 7.80663 12.095 7.80642C12.0366 7.80622 11.9787 7.81751 11.9247 7.83967C11.8707 7.86183 11.8215 7.89441 11.7801 7.93556C11.7386 7.97671 11.7057 8.02561 11.6832 8.07949C11.6606 8.13336 11.6489 8.19114 11.6487 8.24954C11.6485 8.30794 11.6598 8.36581 11.682 8.41984C11.7041 8.47387 11.7367 8.52301 11.7779 8.56445L13.4267 10.2222H6.66675V11.1111H13.4267L11.7779 12.7733C11.7316 12.8135 11.6942 12.8628 11.668 12.9181C11.6417 12.9735 11.6271 13.0336 11.6252 13.0948C11.6233 13.156 11.6341 13.217 11.6568 13.2738C11.6795 13.3307 11.7138 13.3823 11.7574 13.4252C11.801 13.4682 11.8531 13.5018 11.9102 13.5237C11.9674 13.5456 12.0285 13.5555 12.0897 13.5527C12.1509 13.55 12.2108 13.5346 12.2657 13.5075C12.3207 13.4805 12.3695 13.4423 12.409 13.3956L15.1112 10.6667L12.409 7.93778Z"
                                fill="#6D7080"
                              />
                              <path d="M4.44434 10.2222H5.77767V11.1111H4.44434V10.2222Z" fill="#6D7080" />
                              <path d="M2.66675 10.2222H3.55564V11.1111H2.66675V10.2222Z" fill="#6D7080" />
                            </svg>
                            <span onClick={(e) => showRangeCalendar(e)} ref={refToggle}>
                              <DateFormat date={dateRange[1]} timezone={null}/>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Projectdashboard-tab-content show">
                    {(() => {
                      if (activeTab === Constants.PROJECT_DASHBOARD) {
                        return (
                          <ProjectDashboardReports
                            params={params()}
                            selectedDepartment={selectedDepartment}
                            selectedDateRange={selectedDateRange}
                            startDate={selectedDateRange[0]}
                            endDate={selectedDateRange[1]}
                            startDateOriginalFormat={selectedDateRangeOriginalFormat[0]}
                            endDateOriginalFormat={selectedDateRangeOriginalFormat[1]}
                            contentTypes={contentTypes}
                          />
                        );
                      } else if (activeTab === Constants.OPERATIONAL_COST) {
                        return (
                          <OperationalCostReports 
                            params={params(true)}
                            selectedDepartment={selectedDepartment} 
                            selectedDateRange={selectedDateRange} 
                            startDate={selectedDateRange[0]}
                            endDate={selectedDateRange[1]}
                            currency={currency}
                          />
                        )
                      } else if (activeTab === Constants.TM_DASHBOARD) {
                        return (
                          <TMDashboardReports
                            params={params()}
                            selectedDepartment={selectedDepartment}
                            selectedDateRange={selectedDateRange}
                            startDate={selectedDateRange[0]}
                            endDate={selectedDateRange[1]}
                            contentTypes={contentTypes}
                          />
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
